import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Typography,
} from "@mui/material";
import React from "react";
import { InputProps } from "./InputProps";
import { SelectFormInputOption } from "./SelectFormInput";
import { useApi } from "../../contexts/ApiContext";

export interface CheckboxesInputOption extends SelectFormInputOption {
  label: string;
  value: string;
}

export type CheckboxesInputPropsType = InputProps & CheckboxesInputOption;

export interface CheckboxesInputProps
  extends Omit<Omit<CheckboxesInputPropsType, "onChange">, "value"> {
  onChange: (values: CheckboxesInputOption[]) => void;
  options: CheckboxesInputOption[];
  caption?: string;
  value?: CheckboxesInputOption[];
  id?: string;
}
const CheckboxesInput: React.FC<CheckboxesInputProps> = ({
  label,
  onChange,
  error,
  helperText,
  options,
  caption,
  value = [],
  id,
}) => {

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <FormControl disabled={isDisabled} id={id}>
      <FormLabel error={error}>{label}</FormLabel>
      {caption && (
        <Typography color={"greyButton"} variant={"caption"}>
          {caption}
        </Typography>
      )}
      {options.map((option: CheckboxesInputOption) => (
        <FormControlLabel
          control={
            <Checkbox
              disabled={isDisabled}
              checked={value.includes(option)}
              onChange={(e) => {
                if (e.target.checked) {
                  onChange([...value, option]);
                } else {
                  onChange(value.filter((v) => v !== option));
                }
              }}
            />
          }
          label={option.label}
        />
      ))}
      <FormHelperText>{helperText ? helperText : " "}</FormHelperText>
    </FormControl>
  );
};

export default CheckboxesInput;
